export default "__VITE_ASSET__BjLLGKO1__"